<template>
  <div class="imp">
    <!-- Reiter „Import" der Einstellungen — das Panel bringt seine Karten selbst mit -->
    <AutoImportPanel />
  </div>
</template>

<script>
import AutoImportPanel from "@/components/Settings/AutoImport/AutoImportPanel";

export default {
  name: "ImportSettingsPanel",
  components: { AutoImportPanel },
};
</script>

<style lang="scss" scoped>
.imp {
  padding-bottom: 40px;
}
</style>
